export const COUPON_TYPE = 'COUPON_TYPE' // 优惠券
export const RESET_COUPON = 'RESET_COUPON' // 优惠券
export const INVOICE_TYPE = 'INVOICE_TYPE' // 发票
export const GAS_STATION = 'GAS_STATION' // 定位
export const IS_ADDINVOICE = 'IS_ADDINVOICE' // 添加发票
export const SET_LOGIN_SHOW = 'SET_LOGIN_SHOW'
export const SET_USER_MASGE = 'SET_USER_MASGE'
export const PUST_MEG = 'PUST_MEG' // 油枪号&加油金额
export const SET_NEED_WALLET = 'SET_NEED_WALLET'


// WEBPACK FOOTER //
// ./src/stores/pay/types.js